<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <BaseButton 
          variant="primary" 
          icon="plus" 
          iconPosition="left" 
          color="green-5"
          class="mr-8" 
          bold
          size="md" 
          @click="showAddUserUI">
          {{ $t('add_employee.add_user') }}
        </BaseButton>
        <BaseButton variant="secondary" color="v1-grey-10" size="md" @click="openChangesHistory">
          {{ $t("auditlog.title") }}
        </BaseButton>
      </template>
    </Header>
    
    <PageContainer>
      <SendAccessInvitation ref="newUserForm" class="mb-20" @close="adding_user = false" @added="onEmployeeAdded" v-if="adding_user"/>
      <template v-for="employee in employees">
          <SendAccessInvitation 
            class="mb-20"
            :employee="employee" 
            :key="employee._id"
            @removed="fetchList"
            @updated="fetchList"/>
        </template>
    </PageContainer>
  </div>
</template>

<script>
import EmployeesAPI from "@/api/employees";
import SendAccessInvitation from "@/components/corporate/SendAccessInvitation.vue"

export default {
  props: {},
  data() {
    return {
      adding_user: false,

      employees: [],
    };
  },
  methods: {
    fetchList() {
      EmployeesAPI.getList()
        .then((data) => {
          console.log(data.employees);
          console.log(this.$store.state.cafe._id);
          this.employees = data.employees.filter(
            (e) => e.cafe_ids.includes(`${this.$store.state.cafe._id}`)
          );
        })
        .catch((error) => {
          this.$store.dispatch("showError", "employees_error");
        });
    },
    onEmployeeAdded() {
      this.fetchList();
      this.adding_user = false;
    },
    openChangesHistory() {
      this.$router.push("/changes_history");
    },
    showAddUserUI() {
      if (this.adding_user) {
        this.$refs.newUserForm.showOutline();
      } else {
        this.adding_user = true;
      }
    }
  },
  mounted() {
    this.fetchList();
  },
  components: {
    SendAccessInvitation
  },
};
</script>

<style scoped>
</style>
